import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=2733d404&scoped=true&"
import script from "./MultipleChoice.vue?vue&type=script&lang=js&"
export * from "./MultipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=2733d404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2733d404",
  null
  
)

export default component.exports